module.exports = __webpack_public_path__ + "static/img/logo.154572c.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/logo.png
// module id = Re59
// module chunks = 1